import validate from 'validate.js';
import { getErrors } from '../error/getErrors';
import { isValid } from '../error/isValid';
import { formAccountDetailsSchema } from '../error/schemas/formAccountDetails';

export const accountDetailsFormErrorHandling = (user, field, value) => {
  let errors = user.errors;

  const message = validate({ [field]: value }, formAccountDetailsSchema);
  errors = getErrors(
    errors,
    field,
    message && message[field] && message[field][0]
  );

  return {
    ...user,
    values: {
      ...user.values,
      [field]: value
    },
    errors,
    isValid: isValid(errors)
  };
};
